import React from 'react';

import FullPageModal from '@/v2/../components/FullPageModal';
import useGetPackageOffers from '@/v2/../components/PackagePage/hooks/useGetPackageOffers';
import Skeleton from '@/v2/../components/Skeleton';
import { GOOGLE_MAPS_KEY } from '@/v2/../config';
import usePropertyContent from '@/v2/../hooks/usePropertyContent';
import GoogleMap from '@/v2/../shared/components/GoogleMap';

const Map = ({ onClose }: { onClose: () => void }) => {
  const propertyContent = usePropertyContent();
  const { loading } = useGetPackageOffers();

  return (
    <FullPageModal onClose={onClose}>
      <FullPageModal.Header>
        <Skeleton type="Base" visible={loading}>
          {propertyContent.name}
        </Skeleton>
      </FullPageModal.Header>
      {/* @ts-expect-error Consuming JSX component using propTypes (types missing) */}
      <FullPageModal.Body>
        <Skeleton type="Base" visible={loading}>
          {/* @ts-expect-error Consuming JSX component using propTypes (types missing) */}
          <GoogleMap
            apiKey={GOOGLE_MAPS_KEY}
            center={propertyContent.geolocation}
            pins={[
              {
                ...propertyContent.geolocation,
                title: propertyContent.name,
              },
            ]}
            zoom={15}
          />
        </Skeleton>
      </FullPageModal.Body>
    </FullPageModal>
  );
};

export default Map;
